
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecomcategories",
      function () {
        return require("private-next-pages/ecomcategories/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecomcategories"])
      });
    }
  